import {ENV} from "../constant/ENV";

let env = process.env.NODE_ENV

export const config = {
    env: env
}
